export function resolveSpecProperty(property: any) {
  if (!property) {
    return;
  }

  if (Object.getOwnPropertyNames("key")) {
    delete property.key;
  }

  return property;
}

export * from "./contact-us";
export * from "./faqs";
export * from "./glossary";
export * from "./hero";
export * from "./industry";
export * from "./metadata";
export * from "./service-areas";
export * from "./services";
export * from "./small-gallery";
export * from "./spec-adapters";
export * from "./tags";
